module.exports = __webpack_public_path__ + "img/performance-7.329c0b4b.png";